import { BaseActivityEvent } from './BaseActivityEvent'
import { Actor } from './Actor'
import { ArticleInformalFeedbackReviewDismissedEvent, BaseActivityEventProps } from './Types'
import { InformalFeedbackRequestAction } from './InformalFeedbackRequestAction'
import { ProseDisplay } from 'common/ProseInput/ProseDisplay'
import { Dismissed } from 'blaze-ui/icons/20'
import { ReviewSummaryModal } from 'components/ReviewSummaryModal/ReviewSummaryModal'
import { useModals } from 'almanac-ui/Modal'

interface Props extends Partial<BaseActivityEventProps> {
  event: ArticleInformalFeedbackReviewDismissedEvent
}

const ArticleInformalFeedbackReviewDismissed = ({ event, ...props }: Props) => {
  const {
    user,
    data: { message, request_id },
  } = event
  const { actions, ...rest } = props
  const Icon = Dismissed
  const { openModal } = useModals()

  const handleClick = (e: MouseEvent) => {
    openModal(ReviewSummaryModal, { requestId: request_id })
  }

  return (
    <>
      <BaseActivityEvent
        {...rest}
        onClick={handleClick}
        icon={<Icon />}
        timestamp={event.timestamp}
        message={message && <ProseDisplay html={message} />}
        content={
          <>
            <Actor displayName={user.display_name || 'Anonymous User'} userId={user?.id} /> skipped review
          </>
        }
        actions={
          <>
            <InformalFeedbackRequestAction event={event} />
            {actions}
          </>
        }
      />
    </>
  )
}

export { ArticleInformalFeedbackReviewDismissed }
